import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/UnitBuiltFireSafety`
//#region 基本信息
const GetList = `${apiUrl}`
const GetStatusList = `${apiUrl}/GetStatus`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const GetView = (id: number) => `${apiUrl}/view/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
const Close = (id: number) => `${apiUrl}/close/${id}`
const ExportWord = (id: number) => `${apiUrl}/exportWord/${id}?h_np`
const GetRiskInfo = (id: number, fireSafetyId: number) => `${apiUrl}/risk/${id}/${fireSafetyId}`
const PostRiskData = `${apiUrl}/submitRisk`
//#endregion
export const emptyRLData: FireSafetyRLData = {
    Id: 0,
    FireSafetyId: 0,
    RiskLevel: 0,
    Comments: '',
    NewUserId: 0,
    NewDate: new Date(),

    RiskLevelName: '',
    AttachType: 0,
    AttachGuid: '',
    ActionList: []
}
export const emptyHSData: FireSafetyHSData = {
    Id: 0,
    FireSafetyId: 0,
    FireActions: '',
    KitchenFireProof: false,
    KitChenStandGround: false,
    KitChenFuelTypes: '',
    KitChenCombustible: false,
    ElectroWire: false,
    ElectroAging: false,
    ElectroHighPower: false,
    ElectroKnifeSwitch: false,
    ElectroLayWood: false,
    OtherCombustibleType: '',
    OtherCombustibleReserves: 0,
    OtherCombustibleDistance: 0,
    OtherExplosiveType: '',
    OtherExplosiveReserves: 0,
    OtherExplosiveDistance: 0,
    OtherHazardousType: '',
    OtherHazardousReserves: 0,
    OtherHazardousDistance: 0,
    OtherForest: 0,
    OtherGrassland: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    FireActionNames: '',
    KitChenFuelTypeNames: ''
}
export const emptyFLData: FireSafetyFLData = {
    Id: 0,
    FireSafetyId: 0,
    NaturalWater: false,
    NwFlowEnsure: false,
    FirePool: false,
    FpCount: 0,
    FpVolume: 0,
    FpUsable: false,
    CityHydrant: false,
    ChPressure: 0,
    ChWater: 0,
    ChUsable: false,
    OutsideHydrant: false,
    OhTwoWayWater: false,
    OhCount: 0,
    OhUsable: false,
    OhWaterSupplyForm: 0,
    OhAntifreeze: false,
    OhSunkSgin: false,
    OhSeeper: false,
    IndoorHydrant: false,
    IhPipeNetworkRing: false,
    IhCount: 0,
    IhUsable: false,
    IhWaterSupplyForm: 0,
    IhBoxSgin: false,
    IhBoxAssembly: false,
    IhValve: false,
    SprinklerSystem: false,
    SsInstall: false,
    SsUsable: false,
    Extinguisher: false,
    EtValid: false,
    EtRepairSign: false,
    EtGaugeHand: false,
    FireAlarm: false,
    FaTransferForm: 0,
    FaInstall: false,
    FaUsable: false,
    FaDetectorIds: '',
    FaElectricalFireSystem: false,
    FaDetectionValve: false,
    LightningProtection: false,
    UpdateUserId: 0,
    UpdateDate: new Date(),
    NewUserId: 0,
    NewDate: new Date(),

    OhWaterSupplyFormName: '',
    IhWaterSupplyFormName: '',
    FaTransferFormName: '',
    FaDetectorNames: ''
}
export const emptyMRData: FireSafetyMRData = {
    Id: 0,
    FireSafetyId: 0,
    RespMark: false,
    RespImplement: false,
    FacilityProfessional: false,
    FacilityRecord: false,
    FacilityResult: false,
    FacilityProblem: '',
    SafetyProfessional: false,
    SafetyRecord: false,
    SafetyResult: false,
    SafetyProblem: '',
    LightningProtectionProblem: '',
    LightningProtectionProfessional: false,
    LightningProtectionRecord: false,
    LightningProtectionResult: false,
    FireTeamName: '',
    FtDistance: 0,
    FtTime: 0,
    FireStation: false,
    FtNumber: 0,
    FtPartTimeNumber: 0,
    FtDutyNumber: 0,
    FtHalfYearTrain: false,
    FtHalfYearDrill: false,
    FtEngine: '',
    FtMotorPump: 0,
    FtHose: '',
    FtBranch: '',
    FtProtect: 0,
    FtOther: '',
    RoadForm: '',
    RoadPassable: false,
    RoadWidth: 0,
    RoadRing: false,
    UpdateDate: new Date(),
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0
}
export const emptyACData: FireSafetyACData = {
    Id: 0,
    FireSafetyId: 0,
    FaManual: false,
    FaDetector: false,
    FaFireMsg: false,
    FaFaultMsg: false,
    HeInFiveMin: false,
    HeTime: 0,
    HeZenith: false,
    HePumpStartup: false,
    HeWaterLeakage: false,
    UpdateUserId: 0,
    UpdateDate: new Date(),
    NewUserId: 0,
    NewDate: new Date()
}
export const emptyData: FireSafetyData = {
    Id: 0,
    UnitId: 0,
    UnitLocation: '',
    FiresInLastFiveYears: '',
    UnitBaseInfo: '',
    StartAge: '',
    UseUnit: '',
    Manager: '',
    ManageTel: '',
    BuildingCount: 0,
    FloorCount: 0,
    FloorArea: 0,
    BuildArea: 0,
    BuildHeight: 0,
    StructureId: 0,
    UsageNatureIds: '',
    LayoutForm: 0,
    IsAdjacent: false,
    SeparateType: 0,
    SeparateDistance: 0,
    SeparateBy: 0,
    CombustibleSharedId: 0,
    IsCeilingLap: false,
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    UnitCode: '',
    UnitName: '',
    LevelName: '',
    StructureName: '',
    UsageNatureNames: '',
    LayoutFormName: '',
    SeparateTypeName: '',
    SeparateByName: '',
    CombustibleSharedName: '',

    AttachTypePic: 0,
    AttachGuidPic: '',
    HS: emptyHSData,
    FL: emptyFLData,
    MR: emptyMRData,
    AC: emptyACData,
    ActionList: []
}
export interface FireSafetyData {
    [key: string]: any
    Id: number
    UnitId: number
    UnitLocation: string
    FiresInLastFiveYears: string
    UnitBaseInfo: string
    StartAge: string
    UseUnit: string
    Manager: string
    ManageTel: string
    BuildingCount: number
    FloorCount: number
    FloorArea: number
    BuildArea: number
    BuildHeight: number
    StructureId: number
    UsageNatureIds: string
    LayoutForm: number
    IsAdjacent: boolean
    SeparateType: number
    SeparateDistance: number
    SeparateBy: number
    CombustibleSharedId: number
    IsCeilingLap: boolean
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    UnitCode: string
    UnitName: string
    LevelName: string
    StructureName: string
    UsageNatureNames: string
    LayoutFormName: string
    SeparateTypeName: string
    SeparateByName: string
    CombustibleSharedName: string

    AttachTypePic: number
    AttachGuidPic: string
    HS: FireSafetyHSData
    FL: FireSafetyFLData
    MR: FireSafetyMRData
    AC: FireSafetyACData
    ActionList: any
}
//表1－2 文物建筑火灾危险源辨识
export interface FireSafetyHSData {
    [key: string]: any
    Id: number
    FireSafetyId: number
    FireActions: string
    KitchenFireProof: boolean
    KitChenStandGround: boolean
    KitChenFuelTypes: string
    KitChenCombustible: boolean
    ElectroWire: boolean
    ElectroAging: boolean
    ElectroHighPower: boolean
    ElectroKnifeSwitch: boolean
    ElectroLayWood: boolean
    OtherCombustibleType: string
    OtherCombustibleReserves: number
    OtherCombustibleDistance: number
    OtherExplosiveType: string
    OtherExplosiveReserves: number
    OtherExplosiveDistance: number
    OtherHazardousType: string
    OtherHazardousReserves: number
    OtherHazardousDistance: number
    OtherForest: number
    OtherGrassland: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    FireActionNames: string
    KitChenFuelTypeNames: string
}
//表1－3 文物建筑消防设施设备配置使用情况
export interface FireSafetyFLData {
    [key: string]: any
    Id: number
    FireSafetyId: number
    NaturalWater: boolean
    NwFlowEnsure: boolean
    FirePool: boolean
    FpCount: number
    FpVolume: number
    FpUsable: boolean
    CityHydrant: boolean
    ChPressure: number
    ChWater: number
    ChUsable: boolean
    OutsideHydrant: boolean
    OhTwoWayWater: boolean
    OhCount: number
    OhUsable: boolean
    OhWaterSupplyForm: number
    OhAntifreeze: boolean
    OhSunkSgin: boolean
    OhSeeper: boolean
    IndoorHydrant: boolean
    IhPipeNetworkRing: boolean
    IhCount: number
    IhUsable: boolean
    IhWaterSupplyForm: number
    IhBoxSgin: boolean
    IhBoxAssembly: boolean
    IhValve: boolean
    SprinklerSystem: boolean
    SsInstall: boolean
    SsUsable: boolean
    Extinguisher: boolean
    EtValid: boolean
    EtRepairSign: boolean
    EtGaugeHand: boolean
    FireAlarm: boolean
    FaTransferForm: number
    FaInstall: boolean
    FaUsable: boolean
    FaDetectorIds: string
    FaElectricalFireSystem: boolean
    FaDetectionValve: boolean
    LightningProtection: boolean
    UpdateUserId: number
    UpdateDate: Date
    NewUserId: number
    NewDate: Date

    OhWaterSupplyFormName: string
    IhWaterSupplyFormName: string
    FaTransferFormName: string
    FaDetectorNames: string
}
//表1－4 消防管理维护及救援力量情况
export interface FireSafetyMRData {
    [key: string]: any
    Id: number
    FireSafetyId: number
    RespMark: boolean
    RespImplement: boolean
    FacilityProfessional: boolean
    FacilityRecord: boolean
    FacilityResult: boolean
    FacilityProblem: string
    SafetyProfessional: boolean
    SafetyRecord: boolean
    SafetyResult: boolean
    SafetyProblem: string
    LightningProtectionProblem: string
    LightningProtectionProfessional: boolean
    LightningProtectionRecord: boolean
    LightningProtectionResult: boolean
    FireTeamName: string
    FtDistance: number
    FtTime: number
    FireStation: boolean
    FtNumber: number
    FtPartTimeNumber: number
    FtDutyNumber: number
    FtHalfYearTrain: boolean
    FtHalfYearDrill: boolean
    FtEngine: string
    FtMotorPump: number
    FtHose: string
    FtBranch: string
    FtProtect: number
    FtOther: string
    RoadForm: string
    RoadPassable: boolean
    RoadWidth: number
    RoadRing: boolean
    UpdateDate: Date
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
}
//表1－5 现场实战检查
export interface FireSafetyACData {
    [key: string]: any
    Id: number
    FireSafetyId: number
    FaManual: boolean
    FaDetector: boolean
    FaFireMsg: boolean
    FaFaultMsg: boolean
    HeInFiveMin: boolean
    HeTime: number
    HeZenith: boolean
    HePumpStartup: boolean
    HeWaterLeakage: boolean
    UpdateUserId: number
    UpdateDate: Date
    NewUserId: number
    NewDate: Date
}
//RiskLevel 评级表
export interface FireSafetyRLData {
    [key: string]: any
    Id: number
    FireSafetyId: number
    RiskLevel: number
    Comments: string
    NewUserId: number
    NewDate: Date

    RiskLevelName: string
    AttachType: number
    AttachGuid: string
    ActionList: any
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const closeData = (id: number) => {
    return tryAxios({
        method: 'post',
        url: Close(id)
    })
}
export const getStatusList = (firstType: number) => {
    return tryAxios({
        method: 'get',
        url: GetStatusList,
        params: { type: firstType }
    })
}
export const getList = (param: any) => {
    return tryAxios({
        method: 'get',
        url: GetList,
        params: param
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const viewInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetView(id),
    })
}
export const postData = (form: FireSafetyData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: FireSafetyData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
export const exportWord = (id: number) => {
    return tryAxios({
        method: 'get',
        url: ExportWord(id),
    })
}
export const getRiskInfo = (id: number, fireSafetyId: number) => {
    return tryAxios({
        method: 'get',
        url: GetRiskInfo(id, fireSafetyId),
    })
}
export const postRiskData = (form: FireSafetyRLData) => {
    return tryAxios({
        method: 'post',
        url: PostRiskData,
        data: form
    })
}